import startMusic from "./01_start.mp3";
import taskMusic from "./02_task.MP3";
import finalMusic from "./03_final.MP3";

export const MUSIC_TRACKS = {
    start: startMusic,
    task: taskMusic,
    final: finalMusic,
} as const;

export default MUSIC_TRACKS;
